export default __webpack_public_path__ + "media/zurb/img/services/process/copilots-image-69f250bd1eaa2f5a6e90fb5c90d31716.png";